import TypeAheadSearch from './components/TypeAheadSearch.jsx'
import withTooltip from 'modules/withTooltip';
// Components
export default withTooltip(TypeAheadSearch);
//export { default as TypeAheadSearchForm } from './components/TypeAheadSearchForm.jsx';
